import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import { post } from "../../../actions/general";
import { addNewScore, removeScore, editTask } from "../../../store/plan/actions";
import editPlanScore from "../../../store/plan/actions/editPlanScore";

import LoadableComponent from "./loadable";

const mapDispatchToProps = {
    post,
    addNewScore,
    removeScore,
    editPlanScore,
    editTask,
};

export default connect(null, mapDispatchToProps)(injectIntl(LoadableComponent));
